<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Allocate3')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div>
      <div style="display: flex">
        <cargo-ag-grid
          config-module="26000526"
          :grid-options="syncDialog.gridOptions"
          :column-defs="columnDefs"
          :row-data="syncDialog.rowData"
          :grid-params.sync="syncDialog.gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          style="margin-top: 10px;height: 400px;width: 500px"
          @gridReady="params=>syncDialog.gridApi=params.api"
        />

        <el-form label-position="left" label-width="70px" style="width: 450px;padding-left: 20px; padding-right: 10px">
          <el-form-item :label="''">
            <el-radio-group v-model="form.type" no="1">
              <el-radio v-if="$checkPermission(['button_cabinManagement_AllocateCreateVerify'])" :label="0">{{ $t('CargoMsg.Cargo_CabinCreate1') }}</el-radio>
              <el-radio v-if="$checkPermission(['button_cabinManagement_AllocateCreateSEBooking'])" :label="1">{{ $t('CargoMsg.Cargo_CabinCreate2') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_AuthorizedClient') }}</span>
            <cargo-sales-company-select
              no="customerId"
              class="shipper-selector"
              popper-class="shipper-selector-popper"
              :method-params="{customer:true,companyLob:'seaExport',active:true}"
              :check-credit="true"
              :default-value="form.customerId||''"
              :job="form"
              style="flex: 1;"
              @parentCallBack="p=>{ form.customerId=p.value; loadCompanyUser()}"
            />
          </el-form-item>

          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
            <el-input
              :value="txtSalesOffice"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
            <div style="display: flex;justify-content: space-between">
              <cargo-user-select
                ref="sales"
                no="sales"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="form.sales||''"
                :static-options="salesList"
                :merge-load="true"
                style="flex: 1"
                @change="p=>{form.salesRecord = p.value;salesChangeHandler(p);}"
              />&nbsp;
            </div>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.SalesDepartment') }}</span>
            <cargo-department-new-select
              no="salesOffice"
              :disabled="!form.sales"
              :sales-id="Number(form.sales)"
              :office-id="form.salesOffice"
              :department-id="Number(form.salesDepartment)"
              @change="p=>{form.salesDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OperationCompany')">
            <cargo-office-select
              no="opOffice"
              :disabled="true"
              :office-id="Number(form.opOffice)"
              @change="p=>{form.opOffice=p.value;form.opDepartment=0;}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
            <cargo-department-select
              no="opDepartment"
              :office-id="Number(form.opOffice)"
              :department-id="Number(form.opDepartment)"
              @change="p=>{form.opDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Operation') }}</span>
            <cargo-user-select
              ref="op"
              no="op"
              :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
              :default-value="form.op||''"
              :merge-load="true"
              @change="p=>{form.op=p.value;txtOPChangeHandler(p)}"
            />
          </el-form-item>

        </el-form>
      </div>

    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_Distribution') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect.vue'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import $store from '@/store'
import { Company } from '@/class/model/mdm/Company'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { cache, cacheName } from '@/utils/cacheManager'
import { allocationFunc } from '@/api/booking/cabinManagement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { cleanCircleObject } from '@/utils/commonUtil'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getCacheListByKey, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'AllocationCreate',
  components: {
    cargoUserSelect,
    cargoDepartmentSelect,
    cargoDepartmentNewSelect,
    cargoOfficeSelect, CargoSalesCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    list: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      fullscreenLoading: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      txtSalesOffice: '',
      salesList: [],
      syncDialog: {
        gridApi: null,
        gridParams: {},
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true
        }
      },
      form: {
        type: 0,
        customerId: 0,
        lob: 'SE',
        op: 0,
        opOffice: this.$store.getters.currentOfficeId,
        opDepartment: 0,
        customJobType: '',
        sales: 0,
        salesOffice: 0,
        salesDepartment: 0
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [{
        headerName: this.$t('SeaExport.ContainerDescription'),
        field: 'boxTypeQuantity',
        colId: 'boxTypeQuantity',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
        colId: 'shipName',
        field: 'shipName',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
        colId: 'voyage',
        field: 'voyage',
        width: 150
      }, {
        headerName: 'SO NO.',
        colId: 'soNo',
        field: 'soNo',
        width: 150
      }, {
        headerName: 'MBL NO.',
        colId: 'mblNo',
        field: 'mblNo',
        width: 150
      }]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
    }
    await cache.load(cacheName.CONFIG)
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck = Number(cache.config.get('departmentSalesOfficeCheck')) === 1
    this.isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
    if (this.innerVisible) {
      await this.init()
    }
  },
  methods: {
    validateField(field, messageKey) {
      if (!this.form[field] || this.form[field] === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t(messageKey))
        return false
      }
      return true
    },
    async enterHandler() {
      // 空值校验
      if (!this.validateField('customerId', 'CargoMsg.Cargo_AuthorizedClient')) { return }
      if (!this.validateField('sales', 'SeaExport.Sales')) { return }
      if (!this.validateField('salesOffice', 'SeaExport.SalesDepartment')) { return }
      if (!this.validateField('op', 'SeaExport.Operation')) { return }
      if (!this.validateField('opDepartment', 'SeaExport.OperationDepartment')) { return }

      const uuidList = this.list.map(bm => bm.uuid)
      const voList = []
      for (const d of this.list) {
        const vo = {}
        const entityDefValUtil = new EntityDefaultValueUtil(this.$store.getters.currentOfficeId, this)
        if (!entityDefValUtil.defaultValues) {
          await entityDefValUtil.initEntityDefaultValue()
        }
        const job = entityDefValUtil.seaExportJob.getData()
        // 界面填写信息
        this.pageData(job)
        // 组装箱子信息
        this.createContainer(vo, job, d)
        vo.action = 'add'
        vo.job = job
        const mbl = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
        mbl.dispatchingPlace = d.dispatchingPlace // 提单发货地
        const hbl = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
        const loadingPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.loadingPortCode)
        const destinationPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.destinationPortCode)
        // 分单运费条款
        if (job.paymentTermHBL === 'PP') {
          // PP 分单付款地点-----起运港
          hbl.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
        } else if (job.paymentTermHBL === 'CC' || job.paymentTermHBL === '3P') {
          // CC 分单付款地点-----目的港 3r 分单付款地点-----目的港
          hbl.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
        }
        // 主单运费条款
        if (job.paymentTermMBL === 'PP' || job.paymentTermMBL === '3P') {
          // PP 主单付款地点-----起运港
          mbl.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
        } else if (job.paymentTermMBL === 'CC') {
          // CC 主单付款地点-----目的港
          mbl.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
        }
        vo.seaCargoDoc = [mbl, hbl]
        vo.isShowAcPaymentPlaceBL = false
        // 初始化舱单信息
        vo.manifestInfos = [new ManifestInfo().fillDefaultValue().getData()]
        voList.push(vo)
      }
      const loading = getLoading4Cxt(this)
      const data = { type: 1, uuidList: uuidList, vos: voList }
      allocationFunc(data).then(res => {
        this.createSuccessHandler(res)
      }).finally(() => {
        loading.close()
      })
    },
    // 创建成功并弹框
    createSuccessHandler(res) {
      const jobs = res.data
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('CargoMsg.Cargo_CabinCreate3')),
          h('div', { style: 'word-break: break-all;overflow-wrap: break-word;width: 350px; margin: 0 10px;font-size:18px;color:#1F75D5' }, jobs)
        ])
      ])
      this.$confirm(content, this.$t('CargoMsg.Cargo_AllocationSuccessful'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_CloseAndCopyNumber'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Close'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        customClass: 'message-box-width-450',
        type: 'success'
      }).then(() => {
        let input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', jobs)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          this.$message.success(this.$t('SeaExport.CopySuccess'))
        }
        document.body.removeChild(input)
        input = null
        this.$emit('confirmSync')
        this.innerVisible = false
      }).catch((action) => {
        if (action === 'cancel') {
          this.$emit('confirmSync')
        }
        this.innerVisible = false
      })
    },
    async init() {
      if (this.salesOfficeCheck) {
        this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
      } else {
        this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
      }

      this.syncDialog.rowData = this.list
    },
    async loadCompanyUser() {
      if (this.isSpecifiedSalesBusiness) {
        const company = await Company.getCompanyById(this.form.customerId)
        if (company) {
          Company.getCompanyUsers(company.uuid).then(data => {
            this.loadCompanyUserHandler(data)
          })
        }
      } else {
        const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
        const company = companyList.find(p => p.cmpIdx === this.form.customerId)
        let customerDetail
        if (company) {
          customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
        }
        if (customerDetail) {
          const salseTemp = customerDetail.sales
          const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
          const user = userList.find(p => p.userId === salseTemp)
          if (user && user.active) {
            await this.salesChangeHandler({ ...user, value: salseTemp })
          }
        } else {
          await this.salesChangeHandler({ value: 0 })
        }
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.form
      // 销售
      const salesList = []
      let salesDefaultId = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          const userValid = job.fba ? u.lob === SystemConstants.FBA_AE.code : u.lob === job.lob
          if (!u.lob || userValid || u.lob === 'ALL') {
            const user = await User.getUserById(u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      salesList.push(user)
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  salesList.push(user)
                }
              }
            }
          }
        }
      }
      // 销售
      this.salesList = salesList
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        const user = await User.getUserById(job.sales)
        this.$nextTick(() => {
          this.salesChangeHandler({ ...user, value: user.userId })
        })
      }
    },
    txtOPChangeHandler(user) {
      const job = this.form
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    async salesChangeHandler(data) {
      const job = this.form
      job.sales = data.value
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
          const office = await Office.getOfficeById(job.salesOffice)
          this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === $store.getters.currentOfficeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                this.loadCompanyOffice()
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
              this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
            }
          }
        }
      }
    },
    async loadCompanyOffice() {
      const job = this.form
      const office = await Office.getOfficeById(job.salesOffice)
      if (office) {
        this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
      } else {
        this.txtSalesOffice = ''
      }
    },
    close() {
      this.innerVisible = false
    },
    createContainer(vo, job, d) {
      // 关联关系
      job.cabinManagementUuid = d.uuid
      job.availableCabinSpace = true
      job.mbl = d.mblNo
      job.soNo = d.soNo
      job.destinationPortCode = d.deliveryPlace // 交货地
      job.freeDemurrage = d.freeStackDays // 免堆天数
      job.freeDetention = d.freeChestRentPeriod // 免柜租期
      job.eta = d.eta
      job.dischargingPortCode = d.dischargePort // 卸货港
      job.dispatchingPlace = d.dispatchingPlace // 提单发货地
      job.dispatchingPlaceCode = d.loadingPort // 发货地代码
      job.placeOfDeliveryRegion = d.placeOfDeliveryRegion // 交货地区域
      job.carrierVoyage = d.carrierVoyage // 船司内部航次
      job.customerCutoff = d.customerSealDate // 客户截关日期
      job.customerFileCutoff = d.customerCutOffTime // 客户截单时间
      job.customerShutout = d.customerWithdrawalDate // 客户退关日期
      job.etd = d.etd // 开航日期ETD
      job.customCutoff = d.sealingDate // 截关日期
      job.fileCutoff = d.cutOffDate // 截单日期
      job.declareCutOff = d.declarationDate // 截申报日期
      job.voyageFlight = d.voyage // 航次
      job.routeCode = d.routeCode // 航线代码
      job.planner = d.routeManager // 航线负责人
      job.plannerDepartment = d.plannerDepartment // 航线部门
      job.carrierId = d.carrierId // 船公司
      job.scNo = d.scNo // 船公司约号
      job.vessel = d.shipName // 船公司约号
      job.carrierCode = d.shipEdiCode // 船舶EDI代码
      job.vesselCode = d.shipCallSign // 船舶呼号
      job.bookingAgent = d.bookingAgent // 订舱代理
      job.loadingPortCode = d.departurePort // 起运港
      job.cargoType = d.cargoType // 货物类型
      job.transshipment = d.transshipment // 是否转运
      job.transferPortCode = d.transferPortCode // 中转港代码
      job.bookingNo = d.bookingNo // 订舱编号
      if (d.boxTypeQuantity) {
        const seaEQ = []
        const boxList = d.boxTypeQuantity.split('\n')
        for (const box of boxList) {
          const boxValue = box.split('*')
          const seaEq = new SeaEQ().fillDefaultValue().getData()
          seaEq.eqSize = boxValue[1].slice(0, 2)
          seaEq.eqType = boxValue[1].slice(2)
          seaEq.eqQuantity = boxValue[0] || 1
          seaEQ.push(seaEq)
        }
        job.seaEQ = seaEQ
        // 添加箱子信息
        ContainerUtil.autoJustContainerUsages(job)
        vo.seaEQ = job.seaEQ
        vo.containers = job.containers
        // 清理循环引用
        cleanCircleObject(vo)
      }
    },
    pageData(job) {
      job.customerId = this.form.customerId
      job.lob = this.form.lob
      job.op = this.form.op
      job.opOffice = this.form.opOffice
      job.opDepartment = this.form.opDepartment
      job.sales = this.form.sales
      job.salesOffice = this.form.salesOffice
      job.salesDepartment = this.form.salesDepartment
      job.containerLoadType = ContainerLoadType.FCL_CARGO_TYPE.code
      if (this.form.type === 0) {
        // 创建到订舱预审
        job.jobState = -1
        job.preverifyState = 1
      } else {
        job.jobState = 0
        job.preverifyState = 0
      }
    }
  }
}
</script>

<style>
</style>
